import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config";
import PublicNavbar from "../components/PublicNavbar";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(""); // Add error state
  const navigate = useNavigate();

  // Prevent double navbar if already logged in
  useEffect(() => {
    if (localStorage.getItem("token")) {
      // If logged in, redirect to dashboard (or home)
      window.location.href = "/";
    }
    document.title = "Softisans | Login";
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    let isValid = true;
    setPasswordError(""); // Reset error on submit

    if (!email) {
      toast.error("Email is required");
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Enter a valid email");
      isValid = false;
    }
    if (!password || password.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      isValid = false;
    }

    if (!isValid) return;

    try {
      const { data } = await axios.post(`${BASE_URL}api/user/login`, { email, password });

      if (!data.token) {
        throw new Error("No token received");
      }
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      toast.success(data.message);

      // Ensure token is set before navigating
      setTimeout(() => {
        navigate("/dashboard");
      }, 1000); // Small delay to ensure token is available
    } catch (error) {
      console.log("Login error:", error, error?.response);
      if (
        error.response?.status === 401 ||
        error.response?.data?.message === "Invalid email or password" ||
        error.message === "No token received"
      ) {
        setPasswordError("Invalid email or password");
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  return (
    <>
      <PublicNavbar />
      <div className="d-flex flex-column min-vh-100">
        <div className="container d-flex justify-content-center align-items-center flex-grow-1">
          <div className="login-box p-4 shadow rounded bg-white" style={{ width: "100%", maxWidth: "400px" }}>
            <div className="text-center mb-4">
              <img
                src="https://res.cloudinary.com/softisans-com/image/upload/v1592236220/Logo/Softisans-Logo.png"
                alt="Softisans Logo"
                style={{ maxWidth: "180px", width: "60%", height: "auto" }}
              />
            </div>
            <h2 className="text-center">Login</h2>
            <p className="text-center">Access your account by entering credentials.</p>
            <form onSubmit={handleLogin}>
              <div className="form-group mb-3">
                <input
                  type="email"
                  placeholder="Email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-group mb-3">
                <input
                  type="password"
                  placeholder="Password"
                  className={`form-control ${passwordError ? "is-invalid" : ""}`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {passwordError && (
                  <div className="invalid-feedback" style={{ display: "block" }}>
                    {passwordError}
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <button type="submit" className="btn btn-primary">Login</button>
                <a className="linkk ms-2" onClick={() => navigate("/forgot-password")}>Forgot your password?</a>
              </div>
            </form>
            <div className="text-center mt-3">
              {/* <p>
                Don't have an account?{" "}
                <a className="linkk" onClick={() => navigate("/register")}>Sign Up</a>
              </p> */}
              {/* <p>
                <a className="linkk" onClick={() => navigate("/forgot-password")}>Forgot your password?</a>
              </p> */}
            </div>
          </div>
        </div>
        {/* <footer className="bg-dark text-white text-center py-3 mt-auto">
          © {new Date().getFullYear()} rizWork. All rights reserved.
        </footer> */}
      </div>
    </>
  );
};

export default Login;
